export default from './fluid-avatar-image';



// WEBPACK FOOTER //
// ./app/components/fluid-avatar-image/index.js